/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';


import ButtonGroup from '@mui/material/ButtonGroup'
import Button from '@mui/material/Button'
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import StopIcon from '@mui/icons-material/Stop';
import { Box } from '@mui/material';

const Botonera = (props) => {
    const { imagenSiguiente, imagenAnerior, disminuirVelocidad, reproducir, aumentarVelocidad, stop, pause, reproduciendo } = props
    const botones = [
        {
            ocultar: false,
            icono: <SkipPreviousIcon />,
            accion: imagenAnerior,
            nombre: "Imágen anterior"
        },



        {
            ocultar: reproduciendo,
            icono: <PlayArrowIcon />,
            accion: reproducir,
            nombre: "Reproducir"
        },
        {
            ocultar: !reproduciendo,
            icono: <PauseIcon />,
            accion: pause,
            nombre: "Pausar"
        },
        {
            ocultar: false,
            icono: <StopIcon />,
            accion: stop,
            nombre: "Parar"
        },
        {
            ocultar: false,
            icono: <SkipNextIcon />,
            accion: imagenSiguiente,
            nombre: "Imágen siguiente"
        }




    ]


    return (
        <Box
            sx={{
                textAlign: "center",
                marginTop: "0"
            }}
        >

            <ButtonGroup

                variant="contained" aria-label="outlined primary button group" >
                {botones.map((boton, key) => !boton.ocultar && <Button key={key} onClick={boton.accion}>  {boton.icono} </Button>)}
            </ButtonGroup>
        </Box>
    )
}




Botonera.defaultProps = {


}

export default Botonera;